<template>
  <!-- 修改字典对话框 -->
  <el-dialog
      title="修改字典"
      :visible.sync="editDialogVisible"
      width="60%"
  >
    <el-form ref="editFormRef" :rules="rules" :model="editForm" label-width="140px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="名称" prop="name">
            <el-input v-model="editForm.name" placeholder="请输入名称"/>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="banner类型" prop="enumType">
            <el-select v-model="editForm.enumType" clearable placeholder="请选择banner类型" style="width: 100%">
              <el-option key="INDEX" label="首页轮播图" value="INDEX"></el-option>
              <el-option key="RACES" label="比赛" value="RACES"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="排序" prop="sort">
            <el-input v-model="editForm.sort" placeholder="请输入排序" oninput="value=value.replace(/[^\d]/g,'')"/>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="是否启用" prop="enumEnable">
            <el-select v-model="editForm.enumEnable" clearable placeholder="请选择是否启用" style="width: 100%">
              <el-option key="NORMAL" label="是" value="NORMAL"></el-option>
              <el-option key="DISABLE" label="否" value="DISABLE"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="跳转类型">
            <el-select v-model="editForm.skipType" clearable placeholder="请选择跳转类型" style="width: 100%">
              <el-option key="content" label="文章内容" value="content"></el-option>
              <el-option key="path" label="链接地址" value="path"></el-option>
              <el-option key="news" label="已有文章" value="news"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12" v-if="editForm.skipType === 'news'">
          <el-form-item label="选择文章">
            <el-select v-model="editForm.content" filterable placeholder="请选择" style="width: 100%;">
              <el-option
                v-for="item in articlesList"
                :key="item.id"
                :label="item.title"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12" v-if="editForm.skipType === 'path'">
          <el-form-item label="跳转链接" prop="path">
            <el-input v-model="editForm.path" placeholder="请输入跳转链接"/>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="图片MD5值" prop="md5">
            <thumbnail :is-crop="false" v-model="editForm.md5"></thumbnail>
          </el-form-item>
        </el-col>

        <el-col :span="24" v-if="editForm.skipType === 'content'">
          <editor ref="getEditor" v-model="editForm.content" :type="'html'"></editor>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button @click="modifyBanner">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {updateBanner} from "@/api/banner/banner";
import {getPostOrDeleteData} from "@/utils/code";
import Thumbnail from '@/components/common/thumbnail/thumbnails'
import Editor from '@/components/common/editor/editor'
import { getArticlesTitle } from '@/api/article/article'
import { bannerRules } from '@/js/rules'

export default {
  name: "editBanner",
  components: { Thumbnail,Editor },
  data() {
    return {
      editForm: {}, //修改
      editDialogVisible: false,
      bannerStatus: '',
      // 规则
      rules: bannerRules,
      skipType: '',
      articlesList: [],
      queryInfo: {
        keyword: ''
      }
    }
  },

  methods: {
    getMd5B(md5) {
      this.editForm.md5 = md5.md5
    },
    //关闭对话框
    cancel() {
      this.editDialogVisible = false
      this.editForm = {}
    },

    //打开修改对话框
    editDialog(row) {
      this.editForm = JSON.parse(JSON.stringify(row));
      // this.skipType = this.editForm.skipType
      this.getArticlesList()
      this.editDialogVisible = true;
    },

    //获取文章列表
    getArticlesList () {
      getArticlesTitle(this.queryInfo).then(res => {
        this.articlesList = res.code === '0' ? res.data : []
      })
    },

    //确认修改
    modifyBanner() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return;
        updateBanner(this.editForm.id, this.editForm).then((response) => {
          let data = getPostOrDeleteData(response);
          if (data !== null) {
            this.$emit('refresh-list')
            this.editDialogVisible = false;
          }
        })
      });
    },
  }
}
</script>

<style scoped lang="less">
/deep/.el-input {
  width: 90%;
}
</style>
